import { render, staticRenderFns } from "./ManchesterCity.vue?vue&type=template&id=778e566a&scoped=true&"
import script from "./ManchesterCity.vue?vue&type=script&lang=js&"
export * from "./ManchesterCity.vue?vue&type=script&lang=js&"
import style0 from "./ManchesterCity.vue?vue&type=style&index=0&id=778e566a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778e566a",
  null
  
)

export default component.exports